<template>
  <div v-if="userinfos.role === 'ADMIN'" class="head-add">
    <router-link
      v-for="item, i in items"
      :key="i"
      :to="`/operationV2/${id}/${item.path}`"
      class="head_wrapper"
      :class="{ disabled: !id }"
    >
      <div class="circle">
        <i :class="item.icon"></i>
      </div>
      {{ item.name }}
    </router-link>
  </div>
</template>

<script>
  import auth from '../auth'

export default {
  name: "MenuOperation",
  data () {
    return {
      userinfos : auth.getUserInfos()
    }
  },  
  props: {
    id: {
      type: String,
    },
    type: {
      type: String,
    },
  },
  computed: {
    items() {
      return [
        {
          path: 'info',
          name: 'Informations',
          icon: 'fa fa-wrench',
        },
        {
          path: 'config',
          name: 'Configuration',
          icon: 'fa fa-cog',
        },
        {
          path: 'datalists',
          name: 'Listes de données',
          icon: 'fa fa-database',
        },
        {
          path: 'documents',
          name: 'Documents',
          icon: 'fa fa-paperclip',
        },
        {
          path: 'forms',
          name: 'Formulaires',
          icon: 'fa fa-wpforms',
        },
        {
          path: 'data',
          name: 'Participations',
          icon: 'fas fa-sticky-note',
        },
        {
          path: 'counters',
          name: 'Compteurs',
          icon: 'fas fa-stopwatch-20',
        },
        {
          path: 'customize',
          name: 'Customisation',
          icon: 'fa fa-paint-brush',
        },
        ...(this.type === 'JEU AVEC REMBOURSEMENT'
          ? [{
            path: 'odr',
            name: 'ODR',
            icon: 'fas fa-coins',
          },{
            path: 'lots',
            name: 'Lots',
            icon: 'fas fa-gift',
          }] : []
        ),   
        ...(this.type === 'ODR'
          ? [{
            path: 'odr',
            name: 'ODR',
            icon: 'fas fa-coins',
          }] : []
        ),           
        ...(this.type != 'ODR' && this.type != 'JEU AVEC REMBOURSEMENT'
          ? [{
            path: 'lots',
            name: 'Lots',
            icon: 'fas fa-gift',
          }]
          : []
        ),
      ]
    },
  }
}
</script>

<style lang="scss" scoped>
.head-add {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: space-between;
  width: 100%;
  margin: 0 auto;
  font-size: 12px;
  font-weight: bold;
  color: #444444;
  text-transform: uppercase;
  @media (max-width: 981px) {
    justify-content: center;
  }
}

.head_wrapper {
  text-decoration: none;
  color: inherit;
  text-align: center;

  &.disabled {
    pointer-events: none;
    opacity: 0.5;
  }

  &.router-link-active {
    color: #6462f1;

    .circle {
      border-color: #6462f1;
      color: #6462f1;
    }
  }
}
</style>